import React, { PureComponent } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import "jodit/build/jodit.min.css";

import { WithStyles, Typography, Grid, Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import { MyPATExpansionPanel } from "../../common";
import { OrderNotestStyle } from "../styles/OrderNotestStyle";
import clsx from "classnames";
import { Error } from "@material-ui/icons";
import { validateOrderNotes } from "../helpers/createContentRequest";
import { extractContent } from "../../../utils";
import MyPATUploader, { Attachment } from "../../common/MyPATUploader";
import MyPATUploadPreview, {
  convertFileOrUrlToPreviewItem,
} from "../../common/MyPATUploadPreview";
import { SectionFocusedContextValue } from "../../common/MyPATBaseSection";
import CustomInfoIcon from "../../common/CustomInfoIcon";
const { Jodit } = require("jodit");
//import Jodit from "jodit";
interface AddOrderNotesProps extends WithStyles<typeof OrderNotestStyle> {
  classes: any;
  transferToParent: (data: {
    orderNotes: string;
    orderNoteAttachments: (string | File)[];
  }) => void;
  orderNotes: string;
  isSectionDisabled?: boolean;
  orderNoteAttachments?: (string | File)[];
  setSectionFocus: SectionFocusedContextValue["setSectionFocus"];
}

interface AddOrderNotesStates {
  isOpenAddOrderNotesDialog: boolean;
  orderNotes: string;
  orderNoteAttachments: (string | File)[];
}

const ALLOWED_ORDER_NOTE_ATTACHMENTS = [
  "jpg",
  "jpeg",
  "png",
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "msword",
  "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "vnd.openxmlformats-officedocument.wordprocessingml.document",
];

class AddOrderNotes extends PureComponent<
  AddOrderNotesProps,
  AddOrderNotesStates
> {
  jodit: any = {};
  handleJoditOnChange: (value: string) => void;
  constructor(props: AddOrderNotesProps) {
    super(props);
    this.state = {
      isOpenAddOrderNotesDialog: false,
      orderNotes: props.orderNotes,
      orderNoteAttachments: props.orderNoteAttachments
        ? props.orderNoteAttachments
        : [],
    };
    this.jodit = {};
    this.handleJoditOnChange = _.debounce(this.onJoditValueChange, 400);
  }
  onJoditValueChange = (value: string) => {
    this.setState({
      orderNotes: value,
    });
  };

  componentDidUpdate(
    prevProps: AddOrderNotesProps,
    prevState: AddOrderNotesStates
  ) {
    if (
      prevState.orderNotes !== this.state.orderNotes ||
      prevState.orderNoteAttachments !== this.state.orderNoteAttachments
    ) {
      const { orderNotes, orderNoteAttachments } = this.state;
      this.props.transferToParent({
        orderNotes: orderNotes,
        orderNoteAttachments,
      });
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.configureJodit();
    }, 10);
  }

  configureJodit = () => {
    const editorElem = document.getElementById("editor");
    if (!editorElem) {
      return;
    }
    const { setSectionFocus } = this.props;
    this.jodit = new Jodit(editorElem, {
      buttons: joditButtons,
      buttonsMD: joditButtons,
      buttonsSM: joditButtons,
      buttonsXS: joditButtons,
      events: {
        change: this.handleJoditOnChange,
        focus: () => setSectionFocus(true),
        blur: () => setSectionFocus(false),
      },
      askBeforePasteHTML: false,
      enter: "div",
    });

    this.jodit.value = this.state.orderNotes;
  };
  setAttachments = (attachments: Attachment[]) => {
    this.setState({
      orderNoteAttachments: attachments,
    });
  };

  render() {
    const { classes, isSectionDisabled } = this.props;
    const { orderNotes, orderNoteAttachments } = this.state;
    const isError =
      extractContent(orderNotes).length > 0 && !validateOrderNotes(orderNotes);
    return (
      <>
        <Grid
          className={clsx(
            classes.customPanle,
            isSectionDisabled && classes.disabledSection
          )}
        >
          <MyPATExpansionPanel
            defaultExpanded={true}
            variant="white"
            hasExpandIcon={false}
            customCollapseTitle={
              <>
                <Typography variant="h6" className={classes.cardHeading}>
                  Add Order Notes &nbsp;
                  <CustomInfoIcon
                  infoDialogContentType="Add Order Notes"
                  isInfoIcon={true}
                  isRightArrow={false}
                  isCenterArrow={true}
                  knowMoreAbout={false}
                  dialogTitle="Add Order Notes"
                  imageURL="/assets/svg/contentRequest/orderNotesIcon.svg"
                  dialogPara=""
                  details="Click to know more"
                  toolTipDirection="top"
                  htmlElement={
                    <>
                      <Grid container justify="flex-start" className={classes.mtb30}>
                        <Typography className={classes.font16}>In this section you can write a note for the all of the authors tagged in this request  and attach files if needed. Following type of files are allowed:
</Typography>
                        <ul style={{listStyleType: 'none', paddingLeft: '0px'}}>
                          <li className={classes.font16}>1. Word Files (.doc, .docx format)</li>
                          <li className={classes.font16}>2. PDF Files (.pdf format)</li>
                          <li className={classes.font16}>3. Image (.jpeg, .jpg, .png format)</li>
                          <li className={classes.font16}>4. Excel Spreadsheets (.xls, .xlsx format)</li>
                        </ul>
                      </Grid>
                    </>
                  }
                />
                </Typography>
                {isError && (
                  <Typography
                    className={classes.errorText}
                    variant="caption"
                    color="error"
                  >
                    <Error /> Please enter at least 5 characters
                  </Typography>
                )}
              </>
            }
          >
            <div className={clsx(isError && classes.errorBorder)}>
              <textarea id="editor" name="editor" />
            </div>
            <Grid container className={classes.verticalSpace}>
              <MyPATUploader
                onChange={this.setAttachments}
                multiple
                maxNoOfSelections={4}
                allowedFileTypes={ALLOWED_ORDER_NOTE_ATTACHMENTS}
                initialAttachments={orderNoteAttachments}
              >
                {({
                  onItemRemove,
                  attachments,
                  loading,
                  errorMsg,
                  error,
                  handleFileChange,
                  multiple,
                }) => {
                  const list = attachments.map((attachment) =>
                    convertFileOrUrlToPreviewItem(attachment)
                  );

                  return (
                    <Grid className={classes.attachFileContainer}>
                      <Grid container justify="flex-start" alignItems="center">
                        <Grid item xs={12}>
                          <Grid className="heading">
                            <Typography>Attach file</Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        alignItems="center"
                        className="uploadPreviewBox"
                      >
                        <MyPATUploadPreview
                          list={list}
                          readOnly={false}
                          onItemRemove={onItemRemove}
                        />

                        {error && (
                          <Grid item xs={12} justify="center">
                            <Typography
                              className={classes.errorText}
                              variant="caption"
                              color="error"
                            >
                              <Error />
                              {errorMsg}
                            </Typography>
                          </Grid>
                        )}
                      </Grid>

                      <Grid
                        container
                        justify="center"
                        alignItems="center"
                        className="padding30"
                      >
                        <Grid item>
                          <Button
                            variant="contained"
                            color="primary"
                            className="chooseFileBtn"
                          >
                            <label
                              htmlFor="Order note attachments"
                              className={classes.fileLabel}
                            >
                              <span className="attachmentIcon">
                                <img src="/assets/svg/myLibrary/orderNotes/attachment-icon.svg" />
                              </span>
                              <span>&nbsp;&nbsp;Choose File</span>
                            </label>
                          </Button>
                          {/* <Grid className="buttonSubLabel">
                              <Typography>or simply drop files here</Typography>
                            </Grid> */}
                          <Grid>
                            <input
                              id="Order note attachments"
                              aria-describedby="Add Order note attachments"
                              type="file"
                              onChange={handleFileChange}
                              multiple={multiple || false}
                              className={classes.inputFile}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                }}
              </MyPATUploader>
            </Grid>
          </MyPATExpansionPanel>
        </Grid>
      </>
    );
  }
}

const joditButtons = [
  "brush",
  "|",
  "bold",
  "italic",
  "underline",
  "|",
  "font",
  "fontsize",
  "|",
  "ul",
  "ol",
  "|",
  "left",
  "center",
  "right",
  "justify",
];

// @ts-ignore
export default connect()(withStyles(OrderNotestStyle)(AddOrderNotes));
